import { useEffect } from "react";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import ActivityAction from "../redux/activity/actions";
import dashboardActions from "../redux/dashboard/actions";
import CardLayout from "../components/utils/CardLayout";
import moment from "moment";
import ActivationCount from "../components/utils/ActivationCount";
import {
  isAdmin,
  isDealer,
  isAdminAgent,
  isDealerAgent,
  formatDigits,
} from "../helpers/commonFunction";

const {
  getDashboardCount,
  getMonthlyActivationCount,
  getYearlyActivationCount,
  getPortinInventoryCount,
} = dashboardActions;

function Dashboard() {
  const { tokenData, loading: getUserByTokenLoading } = useSelector(
    (state) => state.auth,
  );
  const dateFormat = process.env.REACT_APP_DATE_FORMAT;
  const timeFormat = process.env.REACT_APP_TIME_FORMAT;
  const { getActivity } = ActivityAction;
  const dispatch = useDispatch();
  const { activityList } = useSelector((state) => state.activity);
  const {
    dashboardCountData,
    monthlyActivationCountData,
    yearlyActivationCountData,
    dashboardLoading,
    dashboardActivityLoading,
    portinCountDataLoading,
    portinCountData,
  } = useSelector((state) => state.dashboard);

  useEffect(() => {
    dispatch(getDashboardCount());
    dispatch(getMonthlyActivationCount());
    // dispatch(getYearlyActivationCount());
    dispatch(getPortinInventoryCount());
  }, []);

  useEffect(() => {
    if (!isAdmin(tokenData)) {
      dispatch(
        getActivity({
          fromDate: "",
          toDate: "",
        }),
      );
    }
  }, [tokenData]);

  let newActivityList =
    activityList &&
    activityList.length > 0 &&
    activityList.map((item, ind) => {
      item.IPAddress = `${item.IPAddress}`.replace("::", "").trim();
      item.IPAddress = `${item.IPAddress}`.replace("ffff:", "").trim();
      return item;
    });

  return (
    <>
      {!getUserByTokenLoading && (
        <CardLayout childCardClass="transparent-bd-hide">
          <div className="container-fluid txn-dash">
            {/* [DESIGN] txn-dash class added */}
            <div className="row">
              <div className="col-lg-4">
                <div className="iq-card iq-card-block iq-card-stretch iq-card-height">
                  <div>
                    <div className="iq-card-header d-flex justify-content-between">
                      <div className="iq-header-title">
                        <h4 className="card-title" id="card-svg">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="30"
                            height="30"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="1.7"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          >
                            <rect x="5" y="3" width="14" height="18" rx="2" />
                            <path d="M9 8h6" />
                            <path d="M9 12h6" />
                            <path d="M9 16h3" />
                            <path d="m15 15 1.5 1.5L19 14" />
                          </svg>
                          Today's Transaction
                        </h4>
                      </div>
                    </div>
                    <div
                      style={{
                        position: "absolute",
                        right: "35px",
                        top: "12px",
                      }}
                    >
                      <i
                        className="ri-refresh-line"
                        onClick={() => dispatch(getMonthlyActivationCount())}
                        style={{ fontSize: "1.2rem", cursor: "pointer" }}
                      ></i>
                    </div>
                  </div>
                  {dashboardActivityLoading ? (
                    <div className="dashboard-activation-loader">
                      <span className="spinner-border" role="status"></span>
                    </div>
                  ) : (
                    <div className="iq-card-body">
                      <ul className="list-inline p-0 m-0">
                        <li className="d-flex mb-4 align-items-center p-3 sell-list border-primary toDayActivation">
                          <div className="media-support-info">
                            <h5>Pending</h5>
                          </div>
                          <div className="iq-card-header-toolbar d-flex align-items-center">
                            <div className="badge badge-textStyle badge-pill badge-primary">
                              {formatDigits(
                                monthlyActivationCountData.TodayPending,
                              )}
                            </div>
                          </div>
                        </li>
                        <li className="d-flex mb-4 align-items-center p-3 sell-list border-success toDayActivation">
                          <div className="media-support-info">
                            <h5>Picked</h5>
                          </div>
                          <div className="iq-card-header-toolbar d-flex align-items-center">
                            <div className="badge badge-textStyle badge-pill badge-spring-green">
                              {formatDigits(
                                monthlyActivationCountData.TodayPicked,
                              )}
                            </div>
                          </div>
                        </li>
                        <li className="d-flex mb-4 align-items-center p-3 sell-list border-success toDayActivation">
                          <div className="media-support-info">
                            <h5>Processing</h5>
                          </div>
                          <div className="iq-card-header-toolbar d-flex align-items-center">
                            <div className="badge badge-textStyle badge-pill badge-success">
                              {formatDigits(
                                monthlyActivationCountData.TodayProcessing,
                              )}
                            </div>
                          </div>
                        </li>
                        <li className="d-flex mb-4 align-items-center p-3 sell-list border-info toDayActivation">
                          <div className="media-support-info">
                            <h5>Processed</h5>
                          </div>
                          <div className="iq-card-header-toolbar d-flex align-items-center">
                            <div className="badge badge-textStyle badge-pill badge-info">
                              {formatDigits(
                                monthlyActivationCountData.TodayProcessed,
                              )}
                            </div>
                          </div>
                        </li>
                        <li className="d-flex align-items-center p-3 sell-list border-danger toDayActivation">
                          <div className="media-support-info">
                            <h5>Cancelled</h5>
                          </div>
                          <div className="iq-card-header-toolbar d-flex align-items-center">
                            <div className="badge badge-textStyle badge-pill badge-danger">
                              {formatDigits(
                                monthlyActivationCountData.TodayCancelled,
                              )}
                            </div>
                          </div>
                        </li>
                      </ul>
                    </div>
                  )}
                </div>
              </div>

              <div className="col-lg-4">
                <div className="iq-card iq-card-block iq-card-stretch iq-card-height">
                  <div>
                    <div>
                      <div className="iq-card-header d-flex justify-content-between">
                        <div className="iq-header-title">
                          <h4 className="card-title" id="card-svg">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="29"
                              height="29"
                              viewBox="0 0 24 24"
                              fill="none"
                              stroke="currentColor"
                              strokeWidth="1.7"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            >
                              <rect x="3" y="4" width="18" height="17" rx="2" />
                              <path d="M16 2v4M8 2v4M3 10h18" />
                              <path d="m7 16 3-3 3 2 4-4" />
                              <path d="M17 11v2h-2" />
                            </svg>
                            Monthly Transaction
                          </h4>
                        </div>
                      </div>
                      <div
                        style={{
                          position: "absolute",
                          right: "35px",
                          top: "12px",
                        }}
                      >
                        <i
                          className="ri-refresh-line"
                          onClick={() => dispatch(getMonthlyActivationCount())}
                          style={{ fontSize: "1.2rem", cursor: "pointer" }}
                        ></i>
                      </div>
                    </div>

                    {dashboardActivityLoading ? (
                      <div className="dashboard-activation-loader-month">
                        <span className="spinner-border" role="status"></span>
                      </div>
                    ) : (
                      <div className="iq-card-body">
                        <ul className="list-inline p-0 m-0">
                          <li className="d-flex mb-3 align-items-center p-3-set sell-list border-primary rounded">
                            <div className="media-support-info">
                              <h5>Total</h5>
                            </div>
                            <div className="iq-card-header-toolbar d-flex align-items-center">
                              <div className="badge badge-textStyle badge-pill badge-primary">
                                {formatDigits(
                                  monthlyActivationCountData.MonthlyTotal,
                                )}
                              </div>
                            </div>
                          </li>
                          <li className="d-flex mb-3 align-items-center p-3-set sell-list border-info rounded">
                            <div className="media-support-info">
                              <h5>Processed</h5>
                            </div>
                            <div className="iq-card-header-toolbar d-flex align-items-center">
                              <div className="badge badge-textStyle badge-pill badge-info">
                                {formatDigits(
                                  monthlyActivationCountData.MonthlyProcessed,
                                )}
                              </div>
                            </div>
                          </li>
                          <li className="d-flex mb-3 align-items-center p-3-set sell-list border-info rounded">
                            <div className="media-support-info">
                              <h5>Picked</h5>
                            </div>
                            <div className="iq-card-header-toolbar d-flex align-items-center">
                              <div className="badge badge-textStyle badge-pill badge-spring-green">
                                {formatDigits(
                                  monthlyActivationCountData.MonthlyPicked,
                                )}
                              </div>
                            </div>
                          </li>
                          <li className="d-flex mb-3 align-items-center p-3-set sell-list border-success">
                            <div className="media-support-info">
                              <h5>Processing</h5>
                            </div>
                            <div className="iq-card-header-toolbar d-flex align-items-center">
                              <div className="badge badge-textStyle badge-pill badge-success">
                                {formatDigits(
                                  monthlyActivationCountData.MonthlyProcessing,
                                )}
                              </div>
                            </div>
                          </li>
                          <li className="d-flex align-items-center p-3-set sell-list border-danger rounded">
                            <div className="media-support-info">
                              <h5>Cancelled</h5>
                            </div>
                            <div className="iq-card-header-toolbar d-flex align-items-center">
                              <div className="badge badge-textStyle badge-pill badge-danger">
                                {formatDigits(
                                  monthlyActivationCountData.MonthlyCancelled,
                                )}
                              </div>
                            </div>
                          </li>
                        </ul>
                      </div>
                    )}
                  </div>
                </div>
              </div>

              <div className="col-sm-12 col-md-4 col-lg-4">
                <div className="iq-card iq-card-block iq-card-stretch iq-card-height">
                  <div>
                    <div className="iq-card-header d-flex justify-content-between">
                      <div className="iq-header-title">
                        <h4 className="card-title" id="card-svg">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="29"
                            height="29"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="1.7"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          >
                            <rect x="3" y="4" width="18" height="17" rx="2" />
                            <path d="M16 2v4M8 2v4M3 10h18" />
                            <path d="M8 15a4 4 0 1 0 1.2-2.8L8 13.5" />
                            <path d="M8 11v2.5h2.5" />
                          </svg>
                          Last Month Transaction
                        </h4>
                      </div>
                      <div
                        style={{
                          position: "absolute",
                          right: "35px",
                          top: "12px",
                        }}
                      >
                        <i
                          className="ri-refresh-line"
                          onClick={() => dispatch(getMonthlyActivationCount())}
                          style={{ fontSize: "1.2rem", cursor: "pointer" }}
                        ></i>
                      </div>
                    </div>

                    {dashboardActivityLoading ? (
                      <div className="dashboard-activation-loader-last-month">
                        <span className="spinner-border" role="status"></span>
                      </div>
                    ) : (
                      <div className="iq-card-body">
                        <ul className="list-inline p-0 m-0">
                          <li className="d-flex mb-3 align-items-center p-3-set sell-list border-primary rounded">
                            <div className="media-support-info">
                              <h5>Total</h5>
                            </div>
                            <div className="iq-card-header-toolbar d-flex align-items-center">
                              <div className="badge badge-textStyle badge-pill badge-primary">
                                {formatDigits(
                                  monthlyActivationCountData.LastMonthTotal,
                                )}
                              </div>
                            </div>
                          </li>
                          <li className="d-flex mb-3 align-items-center p-3-set sell-list border-info rounded">
                            <div className="media-support-info">
                              <h5>Processed</h5>
                            </div>
                            <div className="iq-card-header-toolbar d-flex align-items-center">
                              <div className="badge badge-textStyle badge-pill badge-info">
                                {formatDigits(
                                  monthlyActivationCountData.LastMonthProcessed,
                                )}
                              </div>
                            </div>
                          </li>
                          <li className="d-flex mb-3 align-items-center p-3-set sell-list border-info rounded">
                            <div className="media-support-info">
                              <h5>Picked</h5>
                            </div>
                            <div className="iq-card-header-toolbar d-flex align-items-center">
                              <div className="badge badge-textStyle badge-pill badge-spring-green">
                                {formatDigits(
                                  monthlyActivationCountData.LastMonthPicked,
                                )}
                              </div>
                            </div>
                          </li>
                          <li className="d-flex mb-3 align-items-center p-3-set sell-list border-success rounded">
                            <div className="media-support-info">
                              <h5>Processing</h5>
                            </div>
                            <div className="iq-card-header-toolbar d-flex align-items-center">
                              <div className="badge badge-textStyle badge-pill badge-success">
                                {formatDigits(
                                  monthlyActivationCountData.LastMonthProcessing,
                                )}
                              </div>
                            </div>
                          </li>
                          <li className="d-flex align-items-center p-3-set sell-list border-danger rounded">
                            <div className="media-support-info">
                              <h5>Cancelled</h5>
                            </div>
                            <div className="iq-card-header-toolbar d-flex align-items-center">
                              <div className="badge badge-textStyle badge-pill badge-danger">
                                {formatDigits(
                                  monthlyActivationCountData.LastMonthCancelled,
                                )}
                              </div>
                            </div>
                          </li>
                        </ul>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </CardLayout>
      )}
    </>
  );
}

export default Dashboard;
